import React from 'react';
import { Heart, Users, Award, Globe } from 'lucide-react';
import { motion } from 'framer-motion';
import translations from '../contexts/translations';

const About = ({ language = 'en' }) => {
  const t = translations[language];

  const sections = [
    {
      icon: <Heart className="w-8 h-8 text-orange-600" />,
      title: t.ourStory,
      description: t.ourStoryDesc,
      delay: 0.2
    },
    {
      icon: <Globe className="w-8 h-8 text-orange-600" />,
      title: t.ourMission,
      description: t.ourMissionDesc,
      delay: 0.3
    },
    {
      icon: <Award className="w-8 h-8 text-orange-600" />,
      title: t.ourValues,
      description: t.ourValuesDesc,
      delay: 0.4
    },
    {
      icon: <Users className="w-8 h-8 text-orange-600" />,
      title: t.support,
      description: t.supportDesc,
      delay: 0.5
    }
  ];

  return (
    <div className="py-24 min-h-screen relative overflow-hidden" style={{background: 'linear-gradient(to bottom, #fff7ed, #f9e9d2 80%)'}}>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(255,186,73,0.08),transparent_60%)]"></div>
      <div className="container mx-auto px-6 max-w-7xl relative z-10" style={{ marginTop: '3rem' }}>
        {/* Hero Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-20"
        >
          <span className="inline-block px-5 py-2 rounded-full text-sm font-semibold mb-6 border backdrop-blur-md border-orange-400/30 bg-amber-100/50 text-amber-700">
            {t.aboutUs || 'À propos de nous'}
          </span>
          <h1 className="text-4xl md:text-5xl font-extrabold mb-6 tracking-tight text-amber-900">{t.aboutPageTitle}</h1>
          <p className="text-lg max-w-3xl mx-auto leading-relaxed text-amber-900/80">
            {t.aboutPageSubtitle}
          </p>
        </motion.div>

        {/* Content Sections */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {sections.map((section, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: section.delay }}
              className="bg-white/90 border border-amber-100 rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-300"
            >
              <div className="flex items-center mb-6">
                <div className="p-3 rounded-xl bg-orange-100 mr-4">
                  {section.icon}
                </div>
                <h2 className="text-2xl font-semibold text-amber-900">{section.title}</h2>
              </div>
              <p className="text-amber-900/80 text-lg leading-relaxed">
                {section.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default About;